import withErrorCheck from "../CheckError";
import server from "../Server";

// Read latest games from games_view (used for "Latest matches on eqipa")
// This is intentionally generic; mapping to UI shape is done in the mobile app hook.
export interface ILatestGamesViewRow {
  game_id: number;
  game_type: string;
  game_status: string;
  game_datetime: string;
  game_host_team_name: string;
  game_visitor_team_name: string;
  game_host_score: number | null;
  game_visitor_score: number | null;
  organization_logo: string | null;
  season_summary: string | null;
  host_team_logo: string | null;
  visitor_team_logo: string | null;
  group_name: string | null;
  group_logo: string | null;
}

export const GetLatestGames = async (): Promise<ILatestGamesViewRow[]> => {
  const response = await server
    .from("games_view")
    .select(
      [
        "game_id",
        "game_type",
        "game_status",
        "game_datetime",
        "game_host_team_name",
        "game_visitor_team_name",
        "game_host_score",
        "game_visitor_score",
        "organization_logo",
        "season_summary",
        "host_team_logo",
        "visitor_team_logo",
        "group_name",
        "group_logo",
      ].join(",")
    )
    .in("game_status", ["FINISHED", "FINALIZED"])
    .order("game_datetime", { ascending: false })
    .limit(5);

  return withErrorCheck<ILatestGamesViewRow[]>(response as any) || [];
}
